import {
  DirectionEnum,
  ICoursesCalendarSlotDto,
  RideStatusEnum,
} from "@ryde/shared";

import { IGetCoursesCalendarProducePreviewHintKeyParams } from "./courses-calendar-ride-produce.models";

export const formatCoursesCalendarProduceDirectionLabel = (
  direction: DirectionEnum,
): string => {
  switch (direction) {
    case DirectionEnum.PickUp:
      return "A";
    case DirectionEnum.DropOff:
      return "B";
    default:
      return "—";
  }
};

export const getCoursesCalendarProduceDirectionClassName = (
  direction: DirectionEnum,
): string => {
  switch (direction) {
    case DirectionEnum.PickUp:
      return "cc-ride-produce-dir cc-ride-produce-dir--a";
    case DirectionEnum.DropOff:
      return "cc-ride-produce-dir cc-ride-produce-dir--b";
    default:
      return "cc-ride-produce-dir";
  }
};

export const getCoursesCalendarProducePreviewHintKey = ({
  slotsCount,
  slotsWithoutRideCount,
}: IGetCoursesCalendarProducePreviewHintKeyParams): string => {
  if (slotsCount === 1) {
    return "course.calendar.producePreviewHintSingle";
  }
  if (slotsWithoutRideCount === 1) {
    return "course.calendar.producePreviewHintMultipleOneRide";
  }
  return "course.calendar.producePreviewHintMultiple";
};

export const isCoursesCalendarProduceSlotSkipped = (
  slot: ICoursesCalendarSlotDto,
): boolean => slot.hasRide;

/** Skip reason for slots that already have a ride (esp. Cancelled). */
export const getCoursesCalendarProduceAlreadyCreatedLabelKey = (
  slot: ICoursesCalendarSlotDto,
): string | undefined => {
  if (!slot.hasRide) {
    return undefined;
  }
  if (slot.rideStatus === RideStatusEnum.Canceled) {
    return "course.calendar.produceAlreadyCreatedCanceled";
  }
  return "course.calendar.produceAlreadyCreated";
};

export const toProduceDrawerError = (error: unknown): Error =>
  error instanceof Error ? error : new Error(String(error));
